import { Injector } from "@angular/core";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";
import { AbstractCompositionsEntityListView as AbstractCompositionsEntityListView } from "../../../Data/MedicinalProductData/AbstractCompositionsEntityListView";
import { AbstractCompositionsAutoUploadEntity } from "../Entity/AbstractCompositionsAutoUploadEntity";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";


export class TreeNodeMedicinalProductsAbstractCompositions extends OnDemandSimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new AbstractCompositionsEntityListView(items), "Abstract Compositions", EntityEnum.abstractCompositions);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.scientificname}`;
        return this.addChildNode(AbstractCompositionsAutoUploadEntity,labelTemplate, this, model, this.useHist, true, false);
    }

    override getCriteriaFields(): string[] {
        return ['scientificname','scientificcode'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for Abstract Composition";
    }

    override getOnDemandEntities(): any[] {
        let onDemandEntities: any[] = [];
        if (this.children!.length>0) {
            // is TreeModel
            this.children?.forEach(child => {
                if (child instanceof OnDemandAutoUploadNode) {
                    const onDemandNode = child.getOnDemandEntities();
                    if (Array.isArray(onDemandNode ) || Object.keys(onDemandNode ).length !== 0) {
                        onDemandEntities.push(onDemandNode);  
                    }
                }
            
            });
        } else {
            // is ArrayModel
            onDemandEntities.push(...this.data.model.filter((i:any)=>i.checked && i.checked == true));

        }
        return onDemandEntities;
    }
    
}